import React, { useState, useEffect, useRef } from 'react';
import { Divider, Popconfirm, Card, Tooltip, Switch, Input, Button, Tag, Row, Col, Drawer, Space, Tabs, Form, DatePicker, Select, Spin, Modal } from 'antd';
import Highlighter from 'react-highlight-words';
import { ColumnProps } from 'antd/lib/table';
import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import { useIntl } from 'react-intl';
import { CheckCircleTwoTone ,SearchOutlined, RollbackOutlined, UndoOutlined } from '@ant-design/icons';
import { CSVLink } from 'react-csv';
import { Redirect, useHistory, useLocation } from 'react-router-dom';

import { DestinationService, EndCustomersService } from '@gtpl/shared-services/masters';
import { DestinationDto, EndCustomerDto, EndCustomersDropDownData } from '@gtpl/shared-models/masters';
import moment from 'moment';
import { ContainerStatusEnum, ContainerLoadingStatus, EmployeeRolesEnum, GlobalStatus, UnitRequest } from '@gtpl/shared-models/common-models';
import { ContaierRegisterRequest, ContainerStatusInfo, FilenameDto } from '@gtpl/shared-models/logistics';
import { ContainerRegisterService } from '@gtpl/shared-services/logistics';
import { SaleOrderService } from '@gtpl/shared-services/sale-management';


import Link from 'antd/lib/typography/Link';


import appSettings from 'apps/services/config';
import { FoodTypesDto, PlantsDropDown, ProductDto } from '@gtpl/shared-models/masters';
import ArrowDownOutlined from '@ant-design/icons/lib/icons/ArrowDownOutlined';
/* eslint-disable-next-line */
export interface ContainerReportViewProps { }

export function ContainerReportView(props: ContainerReportViewProps) {

  const [defaultTab, setDefaultTab] = useState<string>('0');
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');

  const [object, setObject] = useState(null);

  const searchInput = useRef(null);
  const [page, setPage] = React.useState(1);
  const columns = useState('');
  const { formatMessage: fm } = useIntl();
  const { TabPane } = Tabs;
  const [updateState, setUpdateState] = useState(false);
  const [coId1, setCoIdState1] = useState<number>(null);
  const [coId2, setCoIdState2] = useState<number>(null);
  const [coId3, setCoIdState3] = useState<number>(null);
  const [coId4, setCoIdState4] = useState<number>(null);
  const [coId5, setCoIdState5] = useState<number>(null);
  const [coId6, setCoIdState6] = useState<number>(null);
  const [coId7, setCoIdState7] = useState<number>(null);
  const [bookSlot, setBookSlot] = useState(false);
  let location = useLocation();
  const { RangePicker } = DatePicker;
  const [etdFromDate, setEtdFromDate] = useState(undefined);
  const [etdToDate, setEtdToDate] = useState(undefined);
  const [destination, setDestination] = useState(undefined);
  const [containerFilters, setContainerFilters] = useState<ContaierRegisterRequest>(null)
  const [saleOrderId, setSaleOrderId] = useState(undefined)
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const [containerData, setContainerData] = useState<ContainerStatusInfo[]>([]);
  const [filtersData, setFiltersData] = useState<ContainerStatusInfo[]>([]);
  const service = new ContainerRegisterService;
  const saleService = new SaleOrderService;
  const [destinationData, setDestinationData] = useState<DestinationDto[]>([]);
  const [destinationDetails, setDestinationDetails] = useState<string[]>([]);
  const [etdData, setEtdData] = useState<string[]>([]);
  const [destinations, setDestinations] = useState<number[]>([]);
  const destinationservice = new DestinationService();
  const history = useHistory();
  const text = <span>Set Previous Status</span>
  const [saleId, setSaleId] = useState(0);
  const plantId = Number(localStorage.getItem('unit_id'));
  const [modelType, setModelType] = useState<string>('');
  const [plantData, setPlantData] = useState<PlantsDropDown[]>([]);


  const download = (filePath) => {
    console.log(filePath);
    // : FilenameDto[]
    
    if (filePath) {
      filePath = filePath.split(",");
      for (const res of filePath) {
        if(res){
          console.log(res);
          setTimeout(() => {
            const response = {
              file: appSettings.logistics_doc_upload_path + `${res}`,
            };
  
            window.open(response.file);
  
          }, 100);
        }
      }
    }
    else {
      AlertMessages.getErrorMessage("Please upload file. ");

    }
  }


  const getColumnSearchProps = (dataIndex: string) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`Sea ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <SearchOutlined type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase())
        : false,
    onFilterDropdownVisibleChange: visible => {
      if (visible) { setTimeout(() => searchInput.current.select()); }
    },
    render: text =>
      text ? (
        searchedColumn === dataIndex ? (
          <Highlighter
            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text.toString()}
          />
        ) : text
      )
        : null

  });

  /**
   * 
   * @param selectedKeys 
   * @param confirm 
   * @param dataIndex 
   */
  function handleSearch(selectedKeys, confirm, dataIndex) {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
    console.log(dataIndex);
  };

  function handleReset(clearFilters) {
    clearFilters();
    setSearchText('');
  };

  const [form] = Form.useForm();
  const { Option } = Select;
  const onFocus = () => {
  }



  /**
   * 
   * @param pagination 
   * @param filters 
   * @param sorter 
   * @param extra 
   */
  const onChange = (pagination, filters, sorter, extra) => {
    console.log('params', pagination, filters, sorter, extra);
  }


  const searchData = () => {
    console.log(form.getFieldValue('etdDateRange')[0]);
    console.log(form.getFieldValue('etdDateRange')[1]);
    const selectedEtdFromDate = moment(form.getFieldValue('etdDateRange')[0]).format("YYYY-MM-DD");
    const selectedEtdToDate = moment(form.getFieldValue('etdDateRange')[1]).format("YYYY-MM-DD");
    const destination = form.getFieldValue('destination');
    console.log(selectedEtdToDate, selectedEtdFromDate, destination);
    let selectedData = filtersData;
    if (selectedEtdFromDate && selectedEtdToDate) {
      selectedData = filtersData.filter(item => moment(item.etd).format("YYYY-MM-DD") > selectedEtdFromDate && moment(item.etd).format("YYYY-MM-DD") < selectedEtdToDate)
    }
    if (destination) {
      selectedData = selectedData.filter(item => item.destination === destination)
    }
    setContainerData(selectedData);
  }

  useEffect(() => {
    getFiltersDropdownData(filtersData);
  }, [filtersData])




  const getFiltersDropdownData = (filtersData) => {
    let etdData: any[] = [];
    let destinationData: any[] = [];
    filtersData.forEach(element => {
      if (element.etd > etdFromDate && element.etd < etdToDate) {
        etdData.push(element.etd)
      }
      if (element.destination) {
        destinationData.push(element.destination)
      }
    });
    setDestinationDetails(destinationData)
    setEtdData(etdData)
  }

  useEffect(() => {
    let state = location.state != undefined ? location.state : "Ready to Book";
    const locationDefaultState = state;
    console.log(locationDefaultState);
    if (locationDefaultState != undefined) {

      if (locationDefaultState === "BOOKED") {
        console.log('Booked');
        setDefaultTab("3");
      }
      else if (locationDefaultState === "Containers in Plant") {
        console.log('Dispatch to plant');

        setDefaultTab("4");
      }
      else if (locationDefaultState === "Ready to Book") {
        console.log('ready to book');
        setDefaultTab("2");
      }
      else if (locationDefaultState === "Loading") {
        console.log('Loading');
        setDefaultTab("5");
      }
      else {
        console.log('Default');
        setDefaultTab("2");
      }
    }
    getFinalDestinationData();
    // setTimeout(() => setLoading(false), 1000); 

    getAllContainerStatus();

  }, [])

  const getAllContainerStatus = () => {
    const unitReq = new UnitRequest(Number(localStorage.getItem('unit_id')), JSON.parse(localStorage.getItem('role')));
    service.getAllContainerStatusInfo(unitReq).then(res => {
      if (res.status) {
        setContainerData(res.data);
        setFiltersData(res.data);
        console.log(res.data);
      } else {
        if (res.intlCode) {
          AlertMessages.getErrorMessage(res.message);
        } else {
          AlertMessages.getErrorMessage(res.message);
        }
        setContainerData([]);
        setFiltersData([]);
      }
    }).catch(err => {
      AlertMessages.getErrorMessage(err.message);
      setContainerData([]);
      setFiltersData([]);
    })
  }

  const updateToReadyToBook = (values) => {
    service.updateToReadyToBook(values).then(res => {
      if (!res.status) {
        throw new Error(res.internalMessage);
      } else {
        getAllContainerStatus()

        AlertMessages.getSuccessMessage(res.internalMessage);
      }
    }).catch(err => {
      AlertMessages.getErrorMessage(err.message);
    })
  }
  const updateContainerStatusReadyToBook = (values) => {
    saleService.updateContainerStatusReadyToBook(values).then(res => {
      if (!res.status) {
        throw new Error(res.internalMessage);
      } else {
        getAllContainerStatus()

        AlertMessages.getSuccessMessage(res.internalMessage);
      }
    }).catch(err => {
      AlertMessages.getErrorMessage(err.message);
    })
  }

  const updateToBooked = (values) => {
    service.updateToBooked(values).then(res => {
      if (!res.status) {
        throw new Error(res.internalMessage);
      } else {
        getAllContainerStatus()
        AlertMessages.getSuccessMessage(res.internalMessage);
      }
    }).catch(err => {
      AlertMessages.getErrorMessage(err.message);
    })
  }
  const updateStatusToLoading = (values) => {
    service.updateStatusToLoading(values).then(res => {
      if (!res.status) {
        throw new Error(res.internalMessage);
      } else {
        getAllContainerStatus()
        AlertMessages.getSuccessMessage(res.internalMessage);
      }
    }).catch(err => {
      AlertMessages.getErrorMessage(err.message);
    })
  }

  const updateStatusToDispatchedToPlant = (values) => {
    service.updateToDispatchedToPlant(values).then(res => {
      if (!res.status) {
        throw new Error(res.internalMessage);
      } else {
        getAllContainerStatus()
        AlertMessages.getSuccessMessage(res.internalMessage);
      }
    }).catch(err => {
      AlertMessages.getErrorMessage(err.message);
    })
  }

  const updateToLoading = (values) => {

    service.updateToLoading(values).then(res => {
      if (!res.status) {
        throw new Error(res.internalMessage);
      } else {
        getAllContainerStatus()
        AlertMessages.getSuccessMessage(res.internalMessage);
      }
    }).catch(err => {
      AlertMessages.getErrorMessage(err.message);
    })

  }

  const updateToLoadedAndSealed = (values) => {
    service.updateToLoadedAndSealed(values).then(res => {
      if (!res.status) {
        throw new Error(res.internalMessage);
      } else {
        getAllContainerStatus()
        AlertMessages.getSuccessMessage(res.internalMessage);
      }
    }).catch(err => {
      AlertMessages.getErrorMessage(err.message);
    })
  }

  const getFinalDestinationData = () => {
    destinationservice.getAllActiveDestination().then((res) => {
      if (res.status) {
        setDestinationData(res.data);
      } else {
        // if (res.intlCode) {
        //   AlertMessages.getErrorMessage(res.internalMessage);
        // } else {
        //   AlertMessages.getErrorMessage(res.internalMessage);
        // }
        setDestinationData([]);
      }
    }).catch((err) => {
      AlertMessages.getErrorMessage(err.message);
      setDestinationData([]);
    });
  }

  const setUpdatevalue = (rowdata) => {
    setUpdateState(true);
    setObject(rowdata)
  }

  const setCoId1 = (rowdata) => {
    setUpdateState(true);
    setCoIdState1(rowdata)
  }
  const captureGrossWeight = (saleOrderId) => {
    console.log(saleOrderId)
    setIsModalVisible(true);
    // setBookSlot(true);
    setSaleOrderId(saleOrderId);
    setModelType('gross-weight-form')
  }
  const setCoId2 = (rowdata) => {
    setUpdateState(true);
    setCoIdState2(rowdata)
  }
  const setCoId3 = (rowdata) => {
    setCoIdState3(rowdata)
  }
  const setCoId4 = (rowdata) => {
    setUpdateState(true);
    setCoIdState4(rowdata)
    service.initiateDispatch(rowdata).then(res => {
      if (!res.status) {
        throw new Error(res.internalMessage);
      } else {
        getAllContainerStatus()

        AlertMessages.getSuccessMessage(res.internalMessage);
      }
    }).catch(err => {
      AlertMessages.getErrorMessage(err.message);
    })
  }
  const setCoId5 = (rowdata) => {
    setUpdateState(true);
    setCoIdState5(rowdata)
  }

  const setCoId6 = (rowdata) => {
    if (rowdata.isInvoiced == GlobalStatus.YES) {
      setUpdateState(true);
      setCoIdState6(rowdata)
      service.shipContainer(rowdata).then(res => {
        if (!res.status) {
          throw new Error(res.internalMessage);
        } else {
          getAllContainerStatus()

          AlertMessages.getSuccessMessage(res.internalMessage);
        }
      }).catch(err => {
        AlertMessages.getErrorMessage(err.message);
      })
    } else {
      AlertMessages.getErrorMessage('Invoice should be done to ship the container');
    }
  }

  const handleDestination = (value) => {
    console.log(value)
    setDestination(value)
  }

  const EstimatedFromDate = (value) => {
    if (form.getFieldValue('etdToDate') < value) {
      AlertMessages.getErrorMessage('Estimated From Date must be less than To date ');
      form.setFieldsValue({ estimatedFromDate: '' })
    }
    console.log(value.format('YYYY-MM-DD'));
    setEtdFromDate(value.format('YYYY-MM-DD'))
  }
  const EstimatedToDate = (value) => {
    if (form.getFieldValue('estimatedFromDate') > value) {
      AlertMessages.getErrorMessage('Estimated  To date must be greater than From date ');
      form.setFieldsValue({ etdToDate: '' })
    }
    console.log(form);
    console.log(form.getFieldValue('estimatedFromDate'));
    console.log(value.format('YYYY-MM-DD'));
    setEtdToDate(value.format('YYYY-MM-DD'))
  }
 






  const goToSaleDetailView = (destinationId: number) => {
    setSaleId(destinationId);
    console.log(destinationId);
    setModelType('so-info-view')
    setIsModalVisible(true)
  }

  const tableColumns = (key) => {
    console.log(key);
    const readyToBookColumns: ColumnProps<any>[] = [
      {
        title: 'SNo',
        key: 'saleId',
        width: '60px',
        render: (text, object, index) => (page - 1) * 10 + (index + 1)
      },
      // {
      //   title: 'SO Number',
      //   dataIndex: 'saleOrderNumber',
      //   key: 'saleOrderNumber',
      //   width: 150,
      //   // align:'left',
      //   ...getColumnSearchProps('saleOrderNumber'),
      //   sorter: (a, b) => a.saleOrderId - b.saleOrderId,
      //   sortDirections: ['descend', 'ascend'],
      //   render: (text, record) => <Link onClick={e => goToSaleDetailView(record.saleOrderId)}>{record.saleOrderNumber}</Link>,
      // },
      {
        title: 'Customer PO Number',
        dataIndex: 'poNo',
        key: 'poNo',
        width: 150,
        // align:'left',
        sorter: (a, b) => a.poNo?.localeCompare(b.poNo),
        sortDirections: ['descend', 'ascend'],
        ...getColumnSearchProps('poNo'),
      },
      {
        title: 'Buyer Po Number',
        dataIndex: 'buyerPoNo',
        key: 'buyerPoNo',
        width: 150,
        // align:'left',
        sorter: (a, b) => a.buyerPoNo?.localeCompare(b.buyerPoNo),
        sortDirections: ['descend', 'ascend'],
        ...getColumnSearchProps('buyerPoNo'),
      },
      // {
      //   title: 'Customer Name ',
      //   dataIndex: 'customer',
      //   key: 'customer',
      //   width: 150,
      //   align: 'left',
      //   sorter: (a, b) => a.customer?.localeCompare(b.customer),
      //   sortDirections: ['descend', 'ascend'],
      //   ...getColumnSearchProps('customer'),
      // },
      {
        title: 'ETD',
        dataIndex: 'etd',
        key: 'etd',
        width: 180,
        align: 'left',
        sorter: (a, b) => moment(a.etd).unix() - moment(b.etd).unix(),
        sortDirections: ['descend', 'ascend'],
        render: (value, record: ContainerStatusInfo, index) => {
              return (record.etd) ? moment(record.etd).format("YYYY-MM-DD") : ' - ';
            },
      },


      {
        title: 'Destination',
        dataIndex: 'destination',
        key: 'destination',
        width: 150,
        ...getColumnSearchProps('destination'),
        sorter: (a, b) => a.destination?.localeCompare(b.destination),
        sortDirections: ['descend', 'ascend'],
        // render: (value, record: ContainerStatusInfo, index) => {
        //       return (record.destination) ? record.destination : ' - ';
        //     },


      },
      // {
      //   title: 'Plant',
      //   dataIndex: 'destination', 
      //   width: 150,
      //   sorter: (a, b) => a.scac?.localeCompare(b.scac),
      //   sortDirections: ['descend', 'ascend'],  
      //   ...getColumnSearchProps('destination'),
      //   render: (value, record: ContainerStatusInfo, index) => {
      //     return (record.scac) ? record.scac : ' - ';
      //   },
      // },
      {
        title: 'End Customer',
        dataIndex: 'endCustomer',
        key: 'endCustomer',
        width: 150,
        ...getColumnSearchProps('endCustomer'),
        sorter: (a, b) => a.endCustomer?.localeCompare(b.endCustomer),
        sortDirections: ['descend', 'ascend'],

      },
      // {
      //   title: 'Container Number',
      //   dataIndex: 'containerNo', 
      //   width: 150,
      //   align:'left',
      //   sorter: (a, b) => a.containerNo?.localeCompare(b.containerNo),
      //   sortDirections: ['descend', 'ascend'],  
      //   ...getColumnSearchProps('containerNo'),
      //   render: (value, record: ContainerStatusInfo, index) => {
      //     return (record.containerNo) ? record.containerNo : ' - ';
      //   },
      // },
      // {
      //   title: 'Reference No',
      //   dataIndex: 'referenceNumber', 
      //   width: 150,
      //   sorter: (a, b) => a.referenceNumber?.localeCompare(b.referenceNumber),
      //   sortDirections: ['descend', 'ascend'],  
      //   ...getColumnSearchProps('referenceNumber'),
      //   render: (value, record: ContainerStatusInfo, index) => {
      //     return (record.referenceNumber) ? record.referenceNumber : ' - ';
      //   },
      // },
      // {
      //   title: 'SCAC',
      //   dataIndex: 'scac', 
      //   width: 150,
      //   sorter: (a, b) => a.scac?.localeCompare(b.scac),
      //   sortDirections: ['descend', 'ascend'],  
      //   ...getColumnSearchProps('scac'),
      //   render: (value, record: ContainerStatusInfo, index) => {
      //     return (record.scac) ? record.scac : ' - ';
      //   },
      // },



    ]
    const bookedColumns: ColumnProps<any>[] = [
      {
        title: 'Reference No',
        dataIndex: 'referenceNumber',
        width: 150,
        sorter: (a, b) => a.referenceNumber?.localeCompare(b.referenceNumber),
        sortDirections: ['descend', 'ascend'],
        ...getColumnSearchProps('referenceNumber'),
        render: (value, record: ContainerStatusInfo, index) => {
          return (record.referenceNumber) ? record.referenceNumber : ' - ';
        },
      },
      {
        title: 'SCAC',
        dataIndex: 'scac',
        width: 150,
        sorter: (a, b) => a.scac?.localeCompare(b.scac),
        sortDirections: ['descend', 'ascend'],
        ...getColumnSearchProps('scac'),
        render: (value, record: ContainerStatusInfo, index) => {
          return (record.scac) ? record.scac : ' - ';
        },
      }
    ]
    const plantColumn: ColumnProps<any>[] = [
      {
        title: 'Plant',
        dataIndex: 'plant',
        width: 150,
        sorter: (a, b) => a.plant?.localeCompare(b.plant),
        sortDirections: ['descend', 'ascend'],
        ...getColumnSearchProps('plant'),
      },
    ]
    const containerColumn: ColumnProps<any>[] = [
      {
        title: 'Container Number',
        dataIndex: 'containerNo',
        width: 150,
        align: 'left',
        sorter: (a, b) => a.containerNo?.localeCompare(b.containerNo),
        sortDirections: ['descend', 'ascend'],
        ...getColumnSearchProps('containerNo'),
        render: (value, record: ContainerStatusInfo, index) => {
          return (record.containerNo) ? record.containerNo : ' - ';
        },
      }
    ]
    // const downloadFillSealColumns : ColumnProps<any>[] = [
    //   {
    //     title: 'Download FillSeal',
    //     dataIndex: 'downloadFillSeal',
    //     width: 200,
    //     // responsive: ['lg'],
    //     render: (containerStatus, rowData:ContainerStatusInfo, record) => (
    //       <>
    //         <Button style={{marginLeft:20}} onClick={() => {download(rowData.filePath);}}> <ArrowDownOutlined />Download</Button>

    //       </>
    //     ),
    //   }
    // ]
    const actionColumns: ColumnProps<any>[] = [
      {
        title: 'Action',
        dataIndex: 'containerStatus',
        width: 200,
        // responsive: ['lg'],
        render: (containerStatus, rowData: ContainerStatusInfo, record) => (
          <>
            {containerStatus == ContainerStatusEnum.NOT_READY ? <span>{(coId1) ?
              <Redirect to={{ pathname: "/container-booking", state: coId1 }}
              /> : null}<Button style={{ backgroundColor: '#8fec79', color: "black", fontWeight: 'bold' }}
                onClick={() => { updateContainerStatusReadyToBook(rowData); }}>READY TO BOOK</Button>
              {/* <Divider type="vertical" /><Tooltip placement="top" title={text}><Button><RollbackOutlined /></Button></Tooltip> */}
            </span> :
              containerStatus == ContainerStatusEnum.READY_TO_BOOK ?
                <span>{(coId1) ?
                  <Redirect to={{ pathname: "/container-booking", state: coId1 }}
                  /> : null}
                  {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.LOGISTICS_PLANT_HEAD) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.LOGISTICS_PLANT_EXECUTIVE) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.LOGISTICS_AND_WAREHOUSE_MANAGER) || ((JSON.parse(localStorage.getItem('role'))) === EmployeeRolesEnum.ADMIN)|| ((JSON.parse(localStorage.getItem('role'))) === EmployeeRolesEnum.DOCUMENTATION_MANAGER) || ((JSON.parse(localStorage.getItem('role'))) === EmployeeRolesEnum.LOGISTICS_EXECUTIVE) || ((JSON.parse(localStorage.getItem('role'))) === EmployeeRolesEnum.LOGISTICS_HEAD)) &&
                  <><Tooltip placement="top" title={rowData.grossWeight?"Gross Weight Captured":"Need to Capture Gross Weight"}><Button style={{ backgroundColor: '#d4b106', color: "black", fontWeight: 'bold' }} onClick={() => { captureGrossWeight(rowData.saleOrderId); } }>{rowData.grossWeight?<CheckCircleTwoTone twoToneColor="#52c41a" />:""}GROSS WEIGHT</Button></Tooltip></>
                }
                  {/* {(rowData.grossWeight) ? <Button style={{ backgroundColor: '#722ed1', color: "black", fontWeight: 'bold' }}
                    onClick={() => { setCoId1(rowData); }}>BOOK A SLOT</Button> : ""} */}

                  <Button style={{ backgroundColor: '#722ed1', color: "black", fontWeight: 'bold' }}
                    onClick={() => { setCoId1(rowData); }}>BOOK A SLOT</Button>

                  {/* <Divider type="vertical" /><Tooltip placement="top" title={text}><Button><RollbackOutlined /></Button></Tooltip> */}
                </span> : 
                containerStatus == ContainerStatusEnum.BOOKED ?
                  <span>{(coId2) ? <Redirect to={{ pathname: "/container-dispatch-to-plant", state: coId2 }}
                  /> : null}
                  <Button style={{ backgroundColor: '#faad14', color: "black", fontWeight: 'bold' }}
                        onClick={() => { setCoId2(rowData); } }>ADD CONTAINER NO.</Button><Divider type="vertical" /><Tooltip placement="top" title={text}><Button onClick={() => { updateToReadyToBook(rowData); } }><RollbackOutlined /></Button></Tooltip></span> :
                  containerStatus == ContainerStatusEnum.LOADING ?
                    <span>{(coId3) ? <Redirect to={{ pathname: "/assign-so", state: coId3 }}
                    /> : null}{((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.LOGISTICS_PLANT_HEAD) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.LOGISTICS_AND_WAREHOUSE_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.LOGISTICS_EXECUTIVE)) && <><Tooltip placement="topLeft" title={rowData.loadingStatus == ContainerLoadingStatus.LOADED ?"SO Assigned":" Need to Assign SO"}><Button style={{ backgroundColor: '#d4b106', color: "black", fontWeight: 'bold' }}
                        onClick={() => { setCoId3(rowData); } }>{rowData.loadingStatus == ContainerLoadingStatus.LOADED ?
                          <CheckCircleTwoTone style={{ color: 'green' }} />
                          : ""}ASSIGN SO</Button></Tooltip></>
                      }
                      {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.DOCUMENTATION_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.LOGISTICS_AND_WAREHOUSE_MANAGER) ) &&
                        <Button style={{ backgroundColor: '#faad14', color: "black", fontWeight: 'bold' }} onClick={() => { updateStatusToLoading(rowData) }}>CONFIRM</Button>}
                      {rowData.loadingStatus == ContainerLoadingStatus.LOADED ? ((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.DOCUMENTATION_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.LOGISTICS_AND_WAREHOUSE_MANAGER) ) &&
                        <Button style={{ backgroundColor: '#eb2f96', color: "black", fontWeight: 'bold' }}
                          onClick={() => { setCoId5(rowData); }}>FILL SEAL INFORMATION</Button> : ''}<span>{(coId5) ? <Redirect to={{ pathname: "/fill-seal-info", state: coId5 }}
                          /> : null}</span>
                      <Divider type="vertical" />
                      <Tooltip placement="top" title={text}><Button onClick={() => { updateStatusToDispatchedToPlant(rowData) }}><RollbackOutlined /></Button></Tooltip></span> :
                    containerStatus == ContainerStatusEnum.DISPATCHED_TO_PLANT ?
                      <span>
                        {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.DOCUMENTATION_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.LOGISTICS_AND_WAREHOUSE_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.LOGISTICS_HEAD)) &&
                          <Button style={{ backgroundColor: '#d4b106', color: "black", fontWeight: 'bold' }}
                            onClick={() => { setCoId4(rowData); }}>INITIATE DISPATCH</Button>}
                        <Divider type="vertical" />
                        {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.LOGISTICS_AND_WAREHOUSE_MANAGER)) &&
                          <span>
                          </span>
                        }
                        {((JSON.parse(localStorage.getItem('role')) != EmployeeRolesEnum.LOGISTICS_PLANT_EXECUTIVE)) &&
                        <><Divider type="vertical" /><Tooltip placement="top" title={text}><Button onClick={() => { updateToBooked(rowData); } }><RollbackOutlined /></Button></Tooltip></> }
                      </span> :
                      containerStatus == ContainerStatusEnum.LOADED_AND_SEALED ?
                        <span><Button style={{ backgroundColor: '#08979c', color: "black", fontWeight: 'bold' }}
                          onClick={() => { setCoId6(rowData); }}>SHIP THE CONTAINER</Button>
                          <Divider type="vertical" /><Tooltip placement="top" title={text}><Button onClick={() => { updateToLoading(rowData) }}><RollbackOutlined /></Button></Tooltip><br /><Tooltip placement="top" title={'Download Seal Info'}><Button style={{ marginLeft: 20 }} onClick={() => { download(rowData.filePath); }}> <ArrowDownOutlined />Download</Button></Tooltip></span> :
                        containerStatus == ContainerStatusEnum.SHIPPED ?
                          <span><Divider type="vertical" /><Tooltip placement="top" title={text}><Button onClick={() => { updateToLoadedAndSealed(rowData) }}><RollbackOutlined /></Button></Tooltip></span> : ""}
            {/* <Divider type="vertical" /> */}

            {/* {containerStatus=="NOT_READY"?
  <span>
          {(object) ?<Redirect
            to={{
              pathname: "/container-register-form",
              state: object
            }}
          />:null}<EditOutlined className={'editSamplTypeIcon'} type="edit" name="edit"
            onClick={() => {
              
                setUpdatevalue(rowData);
              
            }}
            style={{ color: '#1890ff', fontSize: '14px' }}
          />
        </span>:""} */}

          </>

        ),
      },
    ]


    if (key === "2") {
      return [...readyToBookColumns, ...bookedColumns, ...plantColumn, ...actionColumns];
    }
    else if (key === "3") {
      return [...readyToBookColumns, ...bookedColumns, ...containerColumn, ...plantColumn, ...actionColumns];
    }
    else if (key === "4") {
      return [...readyToBookColumns, ...bookedColumns, ...containerColumn, ...plantColumn, ...actionColumns]
    }
    else {
      return [...readyToBookColumns, ...plantColumn, ...actionColumns];
    }
  }

  const onReset = () => {
    // form.resetFields();
    form.resetFields();
    setSearchText('');
    // getFiltersDropdownData(filtersData);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    getAllContainerStatus();
  };
  return (
    <>
      
      

      <Card title={<span style={{ color: 'white' }}>Container Register</span>}
        style={{ textAlign: 'center' }} headStyle={{ backgroundColor: '#69c0ff', border: 0 }}>

       
           
        
      </Card>
    </>
  );
}

export default ContainerReportView;